import { createMiddleware } from '@shared/redux';
import { UPDATE_OBJECT_SELECTED, GET_OBJECT_SELECTED } from '@domain/_redux/pareto-ads-app-redux/action/actionTypes';
import { getObjectSelectedData } from '@domain/object-selected';
import { getObjectSelectedFields, getTypeOfSelectedObject } from '@domain/object-selected/object-select.utils';
import { match } from '@shared/utils/match';
import Routes from '@domain/router/routes.constants';
import { shouldShowConversionTypes } from '@domain/dashboard/dashboard.utils';
import { getConversionTypesStats } from './conversion-types.state';

export const getRequestConversionTypes = (state) => {
    const objectSelected = getObjectSelectedData(state);
    const { id, content_type_name: platform } = getObjectSelectedFields(objectSelected);
    if (objectSelected.loadingObjectSelected || !shouldShowConversionTypes(platform)) {
        return null;
    }

    const typeOfSelectedObj = getTypeOfSelectedObject(objectSelected);
    return getConversionTypesStats({
        typeOfSelectedObj,
        selectedId: id,
    });
};

export const conversionTypesMiddleware = createMiddleware({
    [GET_OBJECT_SELECTED]: match(state => state.router.location.pathname, {
        [Routes.CAMPAIGN_MANAGER]: state => getRequestConversionTypes(state),
    }),
    [UPDATE_OBJECT_SELECTED]: match(state => state.router.location.pathname, {
        [Routes.CAMPAIGN_MANAGER]: state => getRequestConversionTypes(state),
    }),
});
